import { Navigate } from 'react-router'
import { useQuery } from '@tanstack/react-query'
import { useAuthStore } from '@/store/auth'
import { fetchMe } from '@/api/auth'
import { Spinner } from '@/components/ui/Spinner'
import { PlayingPageV2 } from '@/components/playing/v2/PlayingPageV2'

export default function PlayingV2Page() {
  const { user } = useAuthStore()

  // Subscribe to the same ['me'] query the layout uses — hits the cache, no extra request.
  // Waiting for it prevents redirecting while isAdmin is still undefined in the persisted store.
  const { data: profile, isLoading } = useQuery({
    queryKey: ['me'],
    queryFn: fetchMe,
    staleTime: 5 * 60 * 1000,
  })

  const isAdmin = profile?.isAdmin ?? user?.isAdmin

  if (isLoading && isAdmin === undefined) return <Spinner />
  if (!isAdmin) return <Navigate to="/playing" replace />

  return <PlayingPageV2 />
}
